import { render, staticRenderFns } from "./MdAboutUsNew.vue?vue&type=template&id=f45eb578&scoped=true&"
import script from "./MdAboutUsNew.vue?vue&type=script&lang=js&"
export * from "./MdAboutUsNew.vue?vue&type=script&lang=js&"
import style0 from "./MdAboutUsNew.vue?vue&type=style&index=0&id=f45eb578&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45eb578",
  null
  
)

export default component.exports